const ADD_CUSTOMER = "ADD_CUSTOMER";
const UPDATE_CUSTOMER = "ADD_CUSTOMER";
const DELETE_CUSTOMER = "DELETE_CUSTOMER";
const CUSTOMERS = "CUSTOMERS";
const ADD_CUSTOMER_ERROR = "ADD_CUSTOMER_ERROR";
const CUSTOMER_DETAILS = "CUSTOMER_DETAILS";

export {
  ADD_CUSTOMER,
  UPDATE_CUSTOMER,
  DELETE_CUSTOMER,
  CUSTOMERS,
  ADD_CUSTOMER_ERROR,
  CUSTOMER_DETAILS,
};
